@if (showLabel()) {
<label>
    <span>{{ label() }}</span>
    @if (required()) {
    <span class="asterisk">*</span>
    }
</label>
}

<!-- floori-field component -->
<ng-content></ng-content>

<div class="errors">
    @if (errors().length > 0) {
    <p class="error" [class.error-right]="errorPosition() === 'right'">
        @if (showErrorIcon()) {
        <floori-icon name="fl_exclamation_mark_s" />
        }
        <span>{{ errors()[0] }}</span>
    </p>
    }
</div>
